<template>
  <v-dialog v-model="dialogStatus" max-width="600" transition="dialog-bottom-transition">
    <v-card>
      <div class="d-flex align-end mb-3">
        <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
          <v-icon color="white"> mdi-bookmark </v-icon>
        </v-card>
        <span class="h4 ml-1 mb-n1">新建任务</span>
      </div>

      <v-form v-model="valid" ref="form" class="px-12 py-3">
        <v-text-field v-model="form.name" label="任务名称" required :rules="rules['taskName']">
        </v-text-field>
        <v-select
          v-model="form.taskEditor"
          :items="taskSceneList"
          label="任务场景"
          no-data-text="暂未创建任务场景"
          required
          :rules="rules['taskEditor']"
          item-text="name"
          item-value="_id"
        ></v-select>
        <v-select
          v-model="form.taskGraphVersion"
          :items="[
            { label: '详细设计', value: 'detail' },
            { label: '模板设计', value: 'template' },
          ]"
          label="任务模式"
          no-data-text="暂未创建任务场景"
          required
          :rules="rules['taskGraphVersion']"
          item-text="label"
          item-value="value"
        ></v-select>
        <v-textarea
          class="mt-2"
          v-model="form.description"
          label="任务描述"
          auto-grow
          clearable
        ></v-textarea>
      </v-form>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click.stop="confirm">提交</v-btn>
        <v-btn color="gray" @click.stop="cancel">取消</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters(['sceneList', 'course']),
    dialogStatus: {
      get() {
        this.$nextTick(() => {
          this.$refs.form?.resetValidation();
        });
        const status = this.$store.state.task.showTaskAdd;
        return status;
      },
      set(val) {
        this.$store.dispatch('task/reverseShowTaskAdd', val);
      },
    },
    taskSceneList() {
      // return this.$store.state.editor.sceneList
      return this.sceneList;
    },
    taskTotal() {
      return this.$store.state.task.taskTotal;
    },
  },
  data: () => ({
    orderNum: null,
    tab: '',
    items: ['基本信息', '任务场景'],
    valid: false,
    treeData: {},
    form: {
      name: '',
      taskMode: '',
      taskEditor: '',
      taskGraphVersion: 'detail',
      description: '',
      isPublic: false,
    },
    rules: {
      name: [v => !!v || '请填写任务名称'],
      taskMode: [v => !!v || '请选择任务模式'],
      taskEditor: [v => !!v || '请选择任务场景'],
      taskGraphVersion: [v => !!v || '请选择任务模式'],
    },
    nodeText: '',
    taskNodeList: [],
    taskModeList: [
      { value: 'study', name: '学习' },
      { value: 'train', name: '练习' },
      { value: 'exam', name: '考核' },
    ],
  }),
  methods: {
    toEditor() {
      const sceneInfo = this.taskSceneList.find(item => item._id === this.form.taskEditor);
      this.$store.dispatch('editor/setSceneInfo', sceneInfo);
      this.$router.push({ path: `/editor/${this.project._id}/${this.form.taskEditor}` });
    },
    showEdit() {
      const sceneInfo = this.taskSceneList.find(item => item._id === this.form.taskEditor);
      this.$store.dispatch('editor/setSceneInfo', sceneInfo);
      this.$store.dispatch('editor/reverseShowSceneEdit', 'edit');
    },
    confirm() {
      this.$refs.form.validate();
      if (this.valid) {
        this.form.cognitionType = 'memory';
        this.form.taskMode = 'study';
        this.form.sortNum = this.taskTotal + 1;
        this.$store.dispatch('task/saveTask', this.form);
        this.$refs.form.reset();
      }
    },
    cancel() {
      this.$store.dispatch('task/reverseShowTaskAdd', false);
    },
  },
  created() {},
  destroyed() {},
};
</script>
